export const parseObservacoesTratamento = (observacaoTratamento) => {
  if (!observacaoTratamento || !observacaoTratamento.trim()) {
    return [];
  }

  const linhas = observacaoTratamento.split('\n').filter(linha => linha.trim());
  const observacoes = [];

  const anexarLinhaContinuacao = (linha) => {
    const ultima = observacoes[observacoes.length - 1];
    if (ultima && (ultima.tipo === 'observacao' || ultima.tipo === 'texto')) {
      ultima.texto = `${ultima.texto}\n${linha}`;
      if (ultima.linhaCompleta) {
        ultima.linhaCompleta = `${ultima.linhaCompleta}\n${linha}`;
      }
      return;
    }

    observacoes.push({
      tipo: 'texto',
      texto: linha
    });
  };

  linhas.forEach(linha => {
    linha = linha.trim();
    if (!linha) return;

    const mudancaStatusMatch = linha.match(/^\[([^\]]+)\]\s*Status alterado de\s+"([^"]+)"\s+para\s+"([^"]+)"\s+por\s+(.+)$/);
    if (mudancaStatusMatch) {
      observacoes.push({
        tipo: 'mudanca_status',
        dataHora: mudancaStatusMatch[1],
        statusAnterior: mudancaStatusMatch[2],
        statusNovo: mudancaStatusMatch[3],
        usuario: mudancaStatusMatch[4],
        texto: linha
      });
      return;
    }

    const observacaoMatch = linha.match(/^\[([^\]]+)\]\s*(.+?):\s*(.+)$/);
    if (observacaoMatch) {
      observacoes.push({
        tipo: 'observacao',
        dataHora: observacaoMatch[1],
        usuario: observacaoMatch[2],
        texto: observacaoMatch[3],
        linhaCompleta: linha
      });
      return;
    }

    anexarLinhaContinuacao(linha);
  });

  return observacoes.reverse();
};
